export const NAMESPACE = 'action-codes';
